import React, { useState } from 'react';
import { Outlet  } from 'react-router-dom';

import Sidebar from 'components/Sidebar/Sidebar';
import Header from 'components/Header/Header';

const AlunaLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}/>

      {/* Sidebar */}
      <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}/>

      {/* Main Content */}
      <main className={`transition-all duration-300 pt-16 ${
        isSidebarOpen ? 'md:ml-72' : 'md:ml-72'
      }`}>
        <div className="p-2 sm:p-6">
          <Outlet />
        </div>
      </main>

      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

    </div>
  );
};

export default AlunaLayout;